<template>
  <div class="features" v-if="product && product.feature">
    <h2 class="light title">Features</h2>
    <Divider />
    <ul class="features-list">
      <li v-for="(feature, index) of product.feature" :key="index" class="features-list-item">
        {{ feature }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Divider from './Divider.vue';

export default {
  name: 'Features',
  components: {
    Divider,
  },
  computed: {
    ...mapState('product', ['product']),
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.features {
  .divider {
    display: none;
  }

  .title {
    margin-bottom: 8px;
  }

  .features-list {
    list-style-type: disc;
    margin-left: 20px;

    .features-list-item {
      display: list-item;
    }
  }

  @media (max-width: $tablet-breakpoint - 1) {
    .divider {
      display: block;
      margin-top: 10px;
      margin-bottom: 24px;
    }
  }
}
</style>
